import { useMemo } from "react";
import { useSelector } from "react-redux";
import { currentCurrency } from "redux/user/selectors";
import { useLoyaltyStore } from "stores/loyalty";
import LoyaltyListRanks from "components/organisms/LoyaltyListRanks";
import { useGetRewardsInfo } from "queries/useGetRewardsInfo";
import { useGetLoyaltyRewardsUser } from "queries/useGetLoyaltyRewardsUser";
import { useGetLoyaltyUser } from "queries/useGetLoyaltyUser";
import { useGetProgressLoyalty } from "queries/useGetProgressLoyalty";
import {
  formatDataProgressLoyaltyRanks,
  getIdsRewardsOnRank,
} from "utils/loyalty";
import useTranslate from "hooks/useTranslate";

const LoyaltyListRanksContainer = () => {
  const t = useTranslate();
  const setIndexActiveRank = useLoyaltyStore(
    (state) => state.setIndexActiveRank,
  );
  const currencyCode = useSelector(currentCurrency);
  const { data: loyaltyUser } = useGetLoyaltyUser();
  const { data: progressUser } = useGetProgressLoyalty();
  const loyalty = loyaltyUser?.data?.data;
  const userExperience = progressUser?.data?.data?.experience || 0;
  const { userRewards } = useGetLoyaltyRewardsUser({ loyaltyId: loyalty?.id });
  const ids = getIdsRewardsOnRank(loyaltyUser?.data?.data, currencyCode);
  const { rewardsInfo } = useGetRewardsInfo(ids);

  const ranks = useMemo(
    () =>
      formatDataProgressLoyaltyRanks({
        t,
        loyalty,
        userExperience,
        userRewards,
        infoRewards: rewardsInfo,
        currencyCode,
      }),
    [loyalty, rewardsInfo, userExperience, userRewards, currencyCode, t],
  );

  // eslint-disable-next-line react/jsx-handler-names
  return <LoyaltyListRanks ranks={ranks} onClickCard={setIndexActiveRank} />;
};

export default LoyaltyListRanksContainer;
